class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      openButton: this.querySelector("[data-js-country-open]"),
      closeButton: this.querySelector("[data-js-country-close]"),
      panel: this.querySelector("dialog"),
    };
    this.elements.closeButton.addEventListener(
      "click",
      this.hidePanel.bind(this)
    );
    this.elements.openButton.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    // this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.openButton.setAttribute("aria-expanded", "false");
    this.elements.panel.close();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
      form.submit();
    }
  }

  openSelector() {
    this.elements.panel.showModal();
    this.elements.openButton.setAttribute(
      "aria-expanded",
      (
        this.elements.openButton.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }

  closeSelector() {
    this.hidePanel();
    this.elements.openButton.focus();
  }
}

customElements.define("localization-form", LocalizationForm);
